import { ForwardedRef, ReactNode, forwardRef } from 'react';
import { isFunction } from 'lodash-es';
import { TextLink } from '../../text-link/text-link.component';
import type { FieldKey } from '../hooks/types';
import { endAdornmentRow } from './field-layout-with-action.styles';
import { FieldLayout } from './field-layout.component';
import type { FieldWithActionProps } from './types';

type Props = FieldWithActionProps<FieldKey> & { endAdornment?: ReactNode };
const FieldLayoutWithActionInner = (
  { actionText = 'Save', actionTrackingId, onActionClick, endAdornment, actionEnabled, ...rest }: Props,
  ref?: ForwardedRef<HTMLDivElement>
) => (
  <FieldLayout
    ref={ref}
    {...rest}
    endAdornment={
      endAdornment ? (
        <div className={endAdornmentRow}>{endAdornment}</div>
      ) : isFunction(onActionClick) ? (
        <TextLink
          size='large'
          trackingId={actionTrackingId}
          onClick={() => {
            if (!rest.error) onActionClick?.();
          }}
          disabled={actionEnabled ? false : !rest.value || !!rest.error || rest.disabled}
        >
          {actionText}
        </TextLink>
      ) : undefined
    }
  />
);

export const FieldLayoutWithAction = forwardRef(FieldLayoutWithActionInner);
